module.exports = __webpack_public_path__ + "img/Popup Alert-Wrong0.91b92071.png";